/**
 * 工作台
 */
<template>
  <div>
	  <div class="main">
		  <div class="title">
			  角色权限管理
		  </div>
		  <div class="iconlist">
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/1.png"/>
				  <div class="icontitle">用户管理</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/4.png"/>
				  <div class="icontitle">角色管理</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/5.png"/>
				  <div class="icontitle">菜单管理</div>
			  </div>
				<div class="iconout">
					<img class="icon" src="../../assets/img/5.png"/>
					<div class="icontitle">经销商管理</div>
				</div>
				<div class="iconout">
					<img class="icon" src="../../assets/img/2.png"/>
					<div class="icontitle">客户管理</div>
				</div>
		  </div>

	  </div>


	  <!-- <div class="main">
		  <div class="title">
			  导购工具
		  </div>
		  <div class="iconlist">
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/3.png"/>
				  <div class="icontitle">方案设计</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/2.png"/>
				  <div class="icontitle">签约管理</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/3.png"/>
				  <div class="icontitle">活动管理</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/1.png"/>
				  <div class="icontitle">客户管理</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/2.png"/>
				  <div class="icontitle">地图管理</div>
			  </div>
		  </div>

	  </div> -->

	  <!-- <div class="main">
		  <div class="title">
			  数据管理
		  </div>
		  <div class="iconlist">
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/1.png"/>
				  <div class="icontitle">数据分析</div>
			  </div>
		  </div>
	  </div>-->

	  <div class="main">
		  <div class="title">
			  导购知识
		  </div>
		  <div class="iconlist">
			 
			  
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/4.png"/>
				  <div class="icontitle">产品介绍</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/4.png"/>
				  <div class="icontitle">产品卖点</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/4.png"/>
				  <div class="icontitle">安装视频</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/1.png"/>
				  <div class="icontitle">用户回访</div>
			  </div>
			  <div class="iconout" >
				  <img class="icon" src="../../assets/img/1.png"/>
				  <div class="icontitle">精品案例</div>
			  </div>
			  <div class="iconout">
				  <img class="icon" src="../../assets/img/5.png"/>
				  <div class="icontitle">竞品对比</div>
			  </div>
		  </div>
	  </div> 


  </div>
</template>

<script>
export default {
  data() {
    return{
      url:''
    }
  },
  methods:{
      navto(url){
        this.$router.push({ path: url })
      }
  }

}
</script>

<style scoped>
.main{
	width: 98%;
	line-height: 20px;
	border-radius: 4px;
	background-color: rgba(255,255,255,1);
	color: rgba(22,93,255,1);
	font-size: 14px;
	text-align: center;
	font-family: Roboto;
	border-radius: 10px;
	padding: 2%;
	margin-bottom: 20px;
}
.title{
	width: 100%;
	height: 27px;
	line-height: 27px;
	color: rgb(16,16,16);
	font-size: 16px;
	text-align: left;
	font-family: AlibabaPuHui-medium;
	margin-left: 20px;
}
.iconlist{
	width: 100%;
	height: 120px;
	margin-top: 20px;
}
.iconout{
	width: 120px;
	height: 120px;
	float: left;
	margin-left: 20px;
	margin-right: 10px;
	text-align: center;
}
.icon{
	width: 62px;
	height: 62px;
}
.icontitle{
	width: 120px;
	height: 25px;
	margin-top: 10px;
	color: black;
	text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/views/index/index.vue